/*
 * @Descripttion:
 * @Date: 2024-02-20 17:48:07
 */
import { ref } from 'vue';
import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';

export const useCheck = ({
  childKey,
  max
}: {
  childKey: string;
  max: number;
}) => {
  const checkData = ref<string[]>([]);

  const { curItem, onChange, group } = useDetailCmpt({
    childKey
  });

  // 页面初始化赋值
  if (curItem.value) {
    checkData.value = curItem.value.split(',');
  }

  const onChangeFn = (v, e) => {
    if (e) {
      //勾选
      checkData.value.push(v);
    } else {
      //取消勾选
      checkData.value = checkData.value.filter(item => item !== v);
    }

    // 最少选择6个
    if (checkData.value.length >= max) {
      onChange(checkData.value.join(','));
    } else {
      onChange('');
    }
  };

  return {
    checkData,
    onChangeFn,
    curItem,
    onChange,
    group
  };
};
